import HelpPageFooterNotice from './HelpPageFooterNotice';

export default HelpPageFooterNotice;
